export const confirmMessage = 'Do you wish to delete active image?';
export const alertMessage =
  "You can't delete image that used in cart.";
